import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    testCcProvisioningAction: {
        method: 'POST',
        url: `${BASE_PATH_API}/testProvisioning/testcc/:merchantApiLoginId`
    },
    testEftProvisioningAction: {
        method: 'POST',
        url: `${BASE_PATH_API}/testProvisioning/testeft/:merchantId`
    }
};

export function TestEpayProvisioning() {
    return createActions(actions);
}
